import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-evaluation",
  "use": "icon-evaluation-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-evaluation\"><defs><style type=\"text/css\"></style></defs><path d=\"M511.3 177.4L606 369.1c11 22.3 32.3 37.8 56.9 41.4l211.6 30.7-153.1 149.3c-17.8 17.4-26 42.4-21.7 66.9l36.1 210.7-189.2-99.5c-10.8-5.7-23-8.7-35.2-8.7-12.2 0-24.4 3-35.2 8.7L287 868.1l36-210.7c4.2-24.5-3.9-49.6-21.7-66.9L148.2 441.3l211.6-30.7c24.6-3.6 45.9-19 56.9-41.4l94.6-191.8m0-80.7c-9.1 0-18.3 4.8-23 14.3L371.9 347c-3.7 7.6-10.9 12.8-19.3 14L92.1 398.9c-21 3.1-29.4 28.9-14.2 43.7l188.5 183.7c6 5.9 8.8 14.4 7.4 22.7l-44.5 259.4c-2.8 16.6 10.3 30 25.2 30 3.9 0 8-0.9 11.9-3l233-122.5c3.7-2 7.8-2.9 11.9-2.9 4.1 0 8.2 1 11.9 2.9l233 122.5c3.9 2.1 8 3 11.9 3 14.9 0 28.1-13.4 25.2-30L748.9 649c-1.4-8.3 1.3-16.8 7.4-22.7l188.5-183.7c15.2-14.8 6.8-40.6-14.2-43.7L670.1 361c-8.3-1.2-15.6-6.5-19.3-14L534.3 111c-4.7-9.5-13.8-14.3-23-14.3z\" p-id=\"10438\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/evaluation.svg
// module id = 7ouR
// module chunks = 97